// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get, isEmpty} from 'lodash';

// Relative Imports
import appActions from '../../actions/actions';
import payoutDetailsActions from '../../actions/payoutDetails';
import PayoutDetails from './PayoutDetails';
import confirmBrandActions from '../../actions/confirmBrand';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', '-1'),
        translations: state.app.translations,
        userType: get(state, 'app.userType', 'IPM'),

        enableContinueButton: get(state, 'payoutDetails.enableContinueButton', false),
        enableBackButton: get(state, 'payoutDetails.enableBackButton', true),
        serviceError: get(state, 'payoutDetails.serviceError', ''),

        currencyList: get(state, 'payoutDetails.currencyList', []),
        currency: get(state, 'payoutDetails.currency', ''),
        currencyError: get(state, 'payoutDetails.currencyError', ''),

        bankingCountryList: get(state, 'payoutDetails.bankingCountryList', []),
        bankingCountryCode: get(state, 'payoutDetails.bankingCountryCode', ''),
        bankingCountryCodeError: get(state, 'payoutDetails.bankingCountryCodeError', ''),

        showBankingState: get(state, 'payoutDetails.showBankingState', false),
        bankingState: get(state, 'payoutDetails.bankingState', ''),
        bankingStateError: get(state, 'payoutDetails.bankingStateError', ''),

        primarySite: get(state, 'payoutDetails.primarySite', {}),
        primarySiteMap: get(state, 'payoutDetails.primarySiteMap', {}),
        siteName: get(state, 'system.siteName', ''),
        bankingCountryInfo: get(state, 'payoutDetails.bankingCountryInfo', {}),
        dyff: get(state,'app.dyff', {}),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        confirmBrandActions: bindActionCreators(confirmBrandActions, dispatch),
        payoutDetailsActions: bindActionCreators(payoutDetailsActions, dispatch),
    };
}

@connect(mapStateToProps, mapDispatchToProps)
class PayoutDetailsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleBankingCountryChange = this.handleBankingCountryChange.bind(this);
        this.handleBankingStateChange = this.handleBankingStateChange.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.showOnFieldBlur = this.showOnFieldBlur.bind(this);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
    }

    componentWillMount() {
        if (isEmpty(this.props.primarySiteMap)) {
            this.props.appActions.enableLoadOverLay(true);
            this.props.payoutDetailsActions.getBankingCountries();
        }
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Payout Details Page');
    }

    handleFormSubmit(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue',
            eventaction: 'Payout Details Page submit'
        }, {});
    }

    handleCurrencyChange(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Currency selected',
            highfrequency: 'true'
        }, {});
        this.setFieldsError(event.target.id);
        this.props.payoutDetailsActions.handleFieldValueChange(event.target.id, event.target.value);
        this.props.payoutDetailsActions.toggleContinueButton();
    }

    handleBankingCountryChange(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Banking country selected',
            highfrequency: 'true'
        }, {});
        this.setFieldsError(event.target.id);
        this.props.payoutDetailsActions.handleFieldValueChange(event.target.id, event.target.value);
        this.props.payoutDetailsActions.toggleContinueButton();
    }

    handleBankingStateChange(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Banking state selected',
            highfrequency: 'true'
        }, {});
        this.setFieldsError(event.target.id);
        this.props.payoutDetailsActions.handleFieldValueChange(event.target.id, event.target.value);
        this.props.payoutDetailsActions.toggleContinueButton();
    }

    showOnFieldBlur(event) {
        event.preventDefault();
        if (!event.target.value.trim()) {
            this.setFieldsError(event.target.id);
            this.props.payoutDetailsActions.setFieldError(event.target.id, 'ipmob.input.field.required');
        }
    }

    handleAlertDismiss() {
        this.props.payoutDetailsActions.dismissAlertBox();
    }


    setFieldsError(errorField) {
        const fields = [
            'bankingCountry',
            'bankingState',
            'currencySelection',
        ];

        for (const fieldVal of fields) {
            if (fieldVal === errorField) {
                this.props.payoutDetailsActions.setFieldError(fieldVal, '');
                break;
            }

            if ((fieldVal === 'bankingCountry' && !this.props.bankingCountryCode)
                || (fieldVal === 'bankingState' && !this.props.bankingState)
                || (fieldVal === 'currencySelection' && !this.props.currency)
            ) {
                this.props.payoutDetailsActions.setFieldError(fieldVal, 'ipmob.input.field.required');
            }
        }
    }

    handleBackButtonClick(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Back'
        });
    }

    render() {
        return (<div>
            <PayoutDetails
                translations={this.props.translations}

                bankingCountryList={this.props.bankingCountryList}
                bankingCountryCode={this.props.bankingCountryCode}
                handleBankingCountryChange={this.handleBankingCountryChange}
                bankingCountryCodeError={this.props.bankingCountryCodeError}
                handleBankingCountryOnBlur={this.showOnFieldBlur}

                showBankingState={this.props.showBankingState}
                bankingState={this.props.bankingState}
                handleBankingStateChange={this.handleBankingStateChange}
                bankingStateError={this.props.bankingStateError}
                handleBankingStateOnBlur={this.showOnFieldBlur}

                currencyList={this.props.currencyList}
                currency={this.props.currency}
                handleCurrencyChange={this.handleCurrencyChange}
                currencyError={this.props.currencyError}
                handleCurrencyOnBlur={this.showOnFieldBlur}

                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}
                enableContinueButton={this.props.enableContinueButton}
                enableBackButton={this.props.enableBackButton}
                handleFormSubmit={this.handleFormSubmit}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                handleBackButtonClick={this.handleBackButtonClick}
            />
        </div>);
    }
}

PayoutDetailsContainer.propTypes = {
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    publicUuid: PropTypes.string,
    bankingCountryCode: PropTypes.string,
    bankingState: PropTypes.string,
    showBankingState: PropTypes.bool,
    bankingCountryList: PropTypes.array, // eslint-disable-line react/forbid-prop-types
    enableContinueButton: PropTypes.bool,
    serviceError: PropTypes.string,
    bankingCountryCodeError: PropTypes.string,
    companyName: PropTypes.string,
    currency: PropTypes.string,
    currencyError: PropTypes.string,
    siteName: PropTypes.string,
    userType: PropTypes.string,
};

PayoutDetailsContainer.defaultProps = {
    publicUuid: '-1',
    bankingCountryCode: '',
    bankingState: '',
    showBankingState: false,
    currencyList: [],
    bankingCountryList: [],
    enableContinueButton: false,
    serviceError: '',
    currency: '',
    currencyError: '',
    companyName: '',
    enableBackButton: true,
    siteName: '',
    userType: 'IPM'
};

export default PayoutDetailsContainer;
